export const tableLabel = [
  {
    label: '需求计划编号',
    param: 'purchaseDemandCode',
    align: 'center',
    minWidth: 140,
    slot: 'purchaseDemandCode',
  },
  {
    label: '需求计划名称',
    param: 'purchaseDemandName',
    align: 'center',
    minWidth: 140,
    tooltip: true,
  },
  {
    label: '创建日期',
    param: 'createTime',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '需求申请人',
    param: 'createMemberName',
    align: 'center',
    minWidth: 110,
  },
  {
    label: '状态',
    param: 'purchaseDemandStatus',
    align: 'center',
    slot: 'purchaseDemandStatus',
    minWidth: 100,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const fieldList = [
  {
    label: '需求计划名称',
    type: 'input',
    value: 'purchaseDemandName',
  },
  {
    label: '需求计划编号',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '创建日期',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
  },
  {
    label: '状态',
    type: 'select',
    value: 'purchaseDemandStatus',
    list: 'purchaseDemandStatusList',
  },
];

export const listTypeInfo = {
  purchaseDemandStatusList: [
    { name: '新建', id: 0 },
    { name: '待审核', id: 1 },
    { name: '审核通过', id: 2 },
    { name: '审核驳回', id: 3 },
    { name: '退回', id: 4 },
  ],
};
